//import Utils
import * as cartUtils from '../pages/Store/Utils/CartUtils';

const initialState = null;

const cartReducer = (state = initialState, action) => {
    switch(action.type){
        //Cart Actions
        case 'LOAD_CART_SUCCESS' : {
            if(action.payload.cart === null) {
                return [];
            }
            return [
                ...action.payload.cart
            ]
        }break;

        case 'LOAD_CART_FAIL' : {
            return [];
        }break;

        case 'ADD_TO_CART_LOCAL' : {
            const {id , typeIndex, quantity} = action.payload;
            return cartUtils.addProduct(state, id, typeIndex, quantity);
        }break;
        case 'REMOVE_FROM_CART_LOCAL' : {
            const { id, typeIndex } = action.payload;
            return cartUtils.removeProduct(state, id, typeIndex);
        }break;
        case 'UPDATE_CART_QUANTITY_LOCAL' : {
            const {index, quantity} = action.payload;
            return cartUtils.updateCartQuantity(state, index, quantity);    
        }break;
        case 'CLEAR_CART_LOCAL' : {
            return [];
        }break;
        case 'CLEAR_CART_IN_REDUCER' : {
            return [];
        }break;
        default : {
            return state;
        }break;

    }
}
export default cartReducer;


// WEBPACK FOOTER //
// ./src/reducers/cartReducer.js